import { ref } from 'vue';

const getClientServiceMetrics = () => {
    const clientservicemetrics_error = ref(null);
    const clientservicemetrics = ref(null);

    const loadClientServiceMetrics = async () => {
      try {
        let data = await fetch("/api/clientservicemetrics");

        if (!data.ok) {
          throw Error("Can't load data");
        }

        clientservicemetrics.value = await data.json();

        // console.log('clientservicemetrics', clientservicemetrics.value);
      } catch (err) {
        clientservicemetrics_error.value = err.message;
      }
    };

    return { clientservicemetrics, clientservicemetrics_error, loadClientServiceMetrics};
}

export default getClientServiceMetrics;